import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
// import KWApp from './KWApp';
// import KWOnboardApp from './KWOnboardApp';
import Settings from './services/settings.service';
import { initializeApp } from 'firebase/app';
import { analytics, performance } from 'firebase';
// import registerServiceWorker from './registerServiceWorker';

// var ref = window.document.getElementsByTagName("script")[0];
// var script = window.document.createElement("script");
// script.src = src;
// script.id = "gmaps";
// script.async = true;
// ref.parentNode.insertBefore(script, ref);



// firebase analytics for KW
if (Settings.get("version") === "_kuwait" && Settings?.firebase_analytics_configs) {
    const app = initializeApp(Settings.firebase_analytics_configs);
    analytics(app);
    performance(app);
}
ReactDOM.render(<App />, document.getElementById('root'));



// ReactDOM.render(Settings.get("version") === "_kuwait" ? <KWApp /> : <App />, document.getElementById('root'));
// registerServiceWorker();
